import React, { useState, useEffect } from 'react';
import LoadingSound from './LoadingSound';
import './LoadingScreen.css';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  const loadingSteps = [
    { text: 'Инициализация системы...', duration: 800 },
    { text: 'Загрузка ресурсов...', duration: 1200 },
    { text: 'Подключение к серверу...', duration: 1000 },
    { text: 'Загрузка данных...', duration: 1500 },
    { text: 'Готово!', duration: 500 }
  ];

  useEffect(() => {
    const totalDuration = loadingSteps.reduce((sum, step) => sum + step.duration, 0);
    const interval = 50;
    const increment = (interval / totalDuration) * 100;

    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setIsComplete(true);
          setTimeout(() => {
            onLoadingComplete();
          }, 1000);
          return 100;
        }
        return prev + increment;
      });
    }, interval);

    // Обновление текущего шага
    const stepTimer = setInterval(() => {
      const currentProgress = progress;
      let stepProgress = 0;
      let currentStepIndex = 0;
      for (let i = 0; i < loadingSteps.length; i++) {
        stepProgress += (loadingSteps[i].duration / totalDuration) * 100;
        if (currentProgress <= stepProgress) {
          currentStepIndex = i;
          break;
        }
      }
      setCurrentStep(currentStepIndex);
    }, 100);

    return () => {
      clearInterval(timer);
      clearInterval(stepTimer);
    };
  }, [progress, onLoadingComplete]);

  return (
    <div className="loading-screen soft-black-bg">
      <LoadingSound isComplete={isComplete} />
      <div className="loading-container neon">
        <div className="loading-title-row">
          <h1 className="loading-title-neon">NOVA CASE</h1>
          <img src="/icons/sticker-frog.png" alt="Pepe" className="loading-pepe" />
        </div>
        <div className="loading-progress-container-neon">
          <div className="loading-progress-bar-neon">
            <div 
              className="loading-progress-fill-neon"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="loading-progress-text-neon">
            {Math.round(progress)}%
          </div>
        </div>
        <div className="loading-step-neon">
          <div className="loading-step-text-neon">
            {loadingSteps[currentStep]?.text || 'Загрузка...'}
          </div>
        </div>
        {isComplete && (
          <div className="loading-complete">
            <div className="complete-checkmark">✓</div>
            <div className="complete-text">Добро пожаловать!</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen; 